/**
 * Essentials24 Live Sales Popup
 * Rotiert Kauf-Nachrichten unten links/rechts
 * Vanilla JS, kein Build-Step
 */
(function () {
  const CONTAINER_SELECTOR = '[data-ps-live-sales-popup]';
  const ITEM_SELECTOR = '[data-ps-sales-item]';

  function init() {
    const container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return;

    const items = container.querySelectorAll(ITEM_SELECTOR);
    if (items.length === 0) return;

    const delayFirst = parseInt(container.dataset.delayFirst || '10', 10) * 1000;
    const displayDuration = parseInt(container.dataset.displayDuration || '5', 10) * 1000;
    const intervalBetween = parseInt(container.dataset.intervalBetween || '30', 10) * 1000;

    let currentIndex = 0;
    let hideTimeout;
    let showTimeout;

    function showItem(index) {
      items.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
      });
      container.classList.add('is-visible');
    }

    function hidePopup() {
      container.classList.remove('is-visible');
      items.forEach((el) => el.classList.remove('is-active'));
    }

    function scheduleNext() {
      hideTimeout = window.setTimeout(() => {
        hidePopup();
        currentIndex = (currentIndex + 1) % items.length;
        showTimeout = window.setTimeout(() => {
          showItem(currentIndex);
          scheduleNext();
        }, intervalBetween);
      }, displayDuration);
    }

    function start() {
      showTimeout = window.setTimeout(() => {
        showItem(0);
        scheduleNext();
      }, delayFirst);
    }

    start();

    // Cleanup on page hide (e.g. navigation)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (hideTimeout) clearTimeout(hideTimeout);
        if (showTimeout) clearTimeout(showTimeout);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
